import React, { useState, useEffect, useContext, useRef } from 'react'
import { Form } from 'react-router-dom'
import Application from "../../../StateContext/Application";
import '../master.css'
import { Cancel32, DeleteRed32, EditBlueBlue32, submit, Tax32, UpdateWhite32 } from '../../../../../public/LoginImages/importimages';
import { useLanguage } from '../../../../../lang/langcontext/LanguageContext';
const Budget = () => {
    const { language, toggleLanguage, t } = useLanguage();
  const statecalls = useContext(Application);
  const { AddBudget, GetBudget, UpdateBudget, DeleteBudget } = statecalls;
 
  const [formData, setFormData] = useState({
    Head: "",
    Fund: "",
    Approvals: "",
  });
  const [tableData, setTableData] = useState([]);
  const [editId, setEditId] = useState(null);
  const formdataref = useRef(null)
  const getbudget = async () => {
    let data = await GetBudget();
    setTableData(data);
  };
 
  useEffect(() => {
    getbudget();
  }, []);
 
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    let data;
    console.log("handlesubmit", formData);
 
    if (editId) {
      data = await UpdateBudget(editId, { id: editId, Head: formData.Head, Fund: formData.Fund, Approvals: formData.Approvals, });
      console.log("EditBud", data);
 
      if (data && data.message === "Budget Updated Successfully") {
        alert(data.message);
      } else {
        alert("Update failed. Please try again.");
      }
    } else {
      data = await AddBudget(formData.Head, formData.Fund, formData.Approvals);
      console.log("addBud", data);
 
      if (data && data.message === "Budget Added Successfully") {
        alert(data.message);
      } else {
        alert("Add failed. Please try again.");
      }
    }
    setEditId(null);
    setFormData({ Head: "", Fund: "", Approvals: "" });
    getbudget();
  };
 
  const handleEdit = (item) => {
    console.log(item);
 
    setFormData({
      Head: item.Head,
      Fund: item.Fund,
      Approvals: item.Approvals,
    });
    setEditId(item.id);
  };
 
  const handleDelete = async (e, id) => {
    e.preventDefault();
    if (window.confirm("Are you sure you want to delete this budget?")) {
      let data = await DeleteBudget(id);
      console.log("Delete response:", data);
 
      if (data && data.message === "Budget Deleted Successfully") {
        alert("Deleted successfully!");
        getbudget();
      } else {
        alert("Delete failed or no response from server.");
      }
    }
  };
  const resetData = () => {
    formdataref.current.reset()
    setFormData([])
  }
  // return (
  //   <div style={{ paddingTop: '20px', backgroundColor: 'rgb(246, 248, 252)',maxHeight: '91vh',overflowY: 'auto' }}>
  //     <h4 style={{ margin: "10px" }}>Budget Master</h4>
  //     <Form onSubmit={handleSubmit} ref={formdataref} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
  //       <div style={{ marginTop: 20, display: 'grid', gap: '2rem', width: '70vw', border: 'none', boxShadow: '0px 0px 10px', padding: '30px', backgroundColor: 'white', borderRadius: '10px', flexWrap: "wrap", }}>
  //         <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
  //           <div style={{ display: 'grid' }} className="col-5">
  //             <label className='form-label col-4' style={{ fontWeight: '700' }}>Head</label>
  //             <input
  //               type="text"
  //               className="form-control" style={{ border: '1px solid darkgray', borderBottom: '1px solid #857979' }}
  //               id="Head"
  //               name="Head"
  //               value={formData.Head}
  //               onChange={handleInputChange}
  //             />
  //           </div>
  //           <div style={{ display: 'grid' }} className="col-5">
  //             <label className='form-label col-4' style={{ fontWeight: '700' }}>Fund</label>
  //             <input
  //               type="number"
  //               className="form-control" style={{ border: '1px solid darkgray', borderBottom: '1px solid #857979' }}
  //               id="Fund"
  //               name="Fund"
  //               value={formData.Fund}
  //               onChange={handleInputChange}
  //             />
  //           </div>
  //         </div>
  //         <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
  //           <div style={{ display: 'grid' }} className="col-5">
  //             <label className='form-label col-4' style={{ fontWeight: '600' }}>Approvals</label>
  //             <input
  //               type="number"
  //               className="form-control" style={{ border: '1px solid darkgray', borderBottom: '1px solid #857979' }}
  //               id="Approvals"
  //               name="Approvals"
  //               value={formData.Approvals}
  //               onChange={handleInputChange}
  //             />
  //           </div>
  //           <div style={{ display: 'grid' }} className="col-5"></div>
  //         </div>
  //         <div style={{ display: 'flex', paddingLeft: '4rem', gap: '10px' }}>
  //           <button type="submit" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: '#502eff', border: 'none', fontSize: '17px', gap: '4px' }}>{editId ? (<img src={UpdateWhite32} style={{ width: "1.2rem", paddingBottom: "3px" }} />) : (<img src={submit} alt="Submit" style={{ width: "1.2rem", paddingBottom: "3px" }} />)}{editId ? "Update" : "Submit"} </button>
  //           <button onClick={resetData} type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: 'red', border: 'none', fontSize: '17px', gap: '4px' }}><img src={Cancel32} style={{ width: '1.2rem', }} /> Cancel</button>
  //         </div>
  //       </div>
  //     </Form>
  //     <div style={{ display: 'grid', justifyContent: 'center', padding: "20px 0px 0px 0px",}}>
  //       <h4 style={{ padding: '10px', fontWeight: '700' }}>Add Bank Master List</h4>
  //       <div style={{ display: 'flex', justifyContent: 'center', width: '75vw', }}>
  //         <table style={{
  //           backgroundColor: '#e8f7f3',
  //           width: '100%',
  //           borderRadius: '20px,20px 0px 0px',
  //           overflow: 'hidden',
  //         }}>
  //           <thead style={{ borderTop: 'none' }}>
  //             <tr
  //               style={{
  //                 backgroundColor: '#ece9fe',
  //                 color: 'black',
  //                 border: 'none',
  //                 borderRadius: '10px',
  //                 overflow: 'hidden',
  //                 height: '2.5rem',
  //               }}>
  //               <th>Sr.No</th>
  //               <th>Head</th>
  //               <th>Fund</th>
  //               <th>Approvals</th>
  //               <th>Actions</th>
  //             </tr>
  //           </thead>
  //           <tbody>
  //             {tableData.map((item, index) => (
  //               <tr key={item.id} style={{
  //                 borderBottom: '2px dotted #ccc',
  //                 backgroundColor: 'white'
  //               }}>
  //                 <td>{index + 1}</td>
  //                 <td>{item.Head}</td>
  //                 <td><img src={Tax32} style={{ width: '1.3rem' }} />
  //                   {item.Fund}</td>
  //                 <td>{item.Approval}</td>
  //                 <td style={{ padding: '8px' }}>
  //                   <button
  //                     onClick={() => handleEdit(item)}
  //                     className="btn btn-custom-edit"
  //                     style={{
  //                       width: '5rem',
  //                       border: '1px solid #502eff',
  //                       backgroundColor: 'white',
  //                       borderRadius: '5px',
  //                       padding: '5px',
  //                       fontSize: '14px',
  //                       color: '#502eff',
  //                       fontWeight: '700'
  //                     }}
  //                   >
  //                     <img className="icon-edit" src={EditBlueBlue32} style={{ width: '1.3rem' }} /> Edit
  //                   </button>
  //                   <button
  //                     onClick={(e) => handleDelete(e, item.id)}
  //                     className="btn btn-custom-delete"
  //                     style={{
  //                       width: '6rem',
  //                       border: '1px solid #ee5d50',
  //                       backgroundColor: 'white',
  //                       borderRadius: '5px',
  //                       padding: '5px',
  //                       marginLeft: '10px',
  //                       color: '#ee5d50',
  //                       fontSize: '14px',
  //                       fontWeight: '700'
  //                     }}
  //                   >
  //                     <img className="icon-delete"
  //                       src={DeleteRed32}
  //                       style={{ width: '1.3rem', paddingBottom: '0.2rem' }}
  //                     />{' '}
  //                     Delete
  //                   </button>
 
  //                 </td>
  //               </tr>
  //             ))}
  //           </tbody>
  //         </table>
  //       </div>
  //     </div>
  //   </div>
  // )
    return (
      <div style={{ paddingTop: '20px', backgroundColor: 'rgb(246, 248, 252)',maxHeight: '91vh',overflowY: 'auto' }}>
        <h4 style={{ margin: "10px" }}>{t("Budget Master")}</h4>
        <Form onSubmit={handleSubmit} ref={formdataref} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <div style={{ marginTop: 20, display: 'grid', gap: '2rem', width: '70vw', border: 'none', boxShadow: '0px 0px 10px', padding: '30px', backgroundColor: 'white', borderRadius: '10px', flexWrap: "wrap", }}>
            <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
              <div style={{ display: 'grid' }} className="col-5">
                <label className='form-label col-4' style={{ fontWeight: '700' }}>{t("Head")}</label>
                <input
                  type="text"
                  className="form-control" style={{ border: '1px solid darkgray', borderBottom: '1px solid #857979' }}
                  id="Head"
                  name="Head"
                  value={formData.Head}
                  onChange={handleInputChange}
                />
              </div>
              <div style={{ display: 'grid' }} className="col-5">
                <label className='form-label col-4' style={{ fontWeight: '700' }}>{t("Fund")}</label>
                <input
                  type="number"
                  className="form-control" style={{ border: '1px solid darkgray', borderBottom: '1px solid #857979' }}
                  id="Fund"
                  name="Fund"
                  value={formData.Fund}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '20px', justifyContent: 'space-evenly' }}>
              <div style={{ display: 'grid' }} className="col-5">
                <label className='form-label col-4' style={{ fontWeight: '600' }}>{t("Approvals")}</label>
                <input
                  type="number"
                  className="form-control" style={{ border: '1px solid darkgray', borderBottom: '1px solid #857979' }}
                  id="Approvals"
                  name="Approvals"
                  value={formData.Approvals}
                  onChange={handleInputChange}
                />
              </div>
              <div style={{ display: 'grid' }} className="col-5"></div>
            </div>
            <div style={{ display: 'flex', paddingLeft: '4rem', gap: '10px' }}>
              <button type="submit" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: '#502eff', border: 'none', fontSize: '17px', gap: '4px' }}>{editId ? (<img src={UpdateWhite32} style={{ width: "1.2rem", paddingBottom: "3px" }} />) : (<img src={submit} alt="Submit" style={{ width: "1.2rem", paddingBottom: "3px" }} />)}{editId ? "Update" : "Submit"} </button>
              <button onClick={resetData} type='button' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: "20px", width: "7rem", height: "2.5rem", backgroundColor: 'red', border: 'none', fontSize: '17px', gap: '4px' }}><img src={Cancel32} style={{ width: '1.2rem', }} /> Cancel</button>
            </div>
          </div>
        </Form>
        <div style={{ display: 'grid', justifyContent: 'center', padding: "20px 0px 0px 0px",}}>
          <h4 style={{ padding: '10px', fontWeight: '700' }}>{t("Add Bank Master List")}</h4>
          <div style={{ display: 'flex', justifyContent: 'center', width: '75vw', }}>
            <table style={{
              backgroundColor: '#e8f7f3',
              width: '100%',
              borderRadius: '20px,20px 0px 0px',
              overflow: 'hidden',
            }}>
              <thead style={{ borderTop: 'none' }}>
                <tr
                  style={{
                    backgroundColor: '#ece9fe',
                    color: 'black',
                    border: 'none',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    height: '2.5rem',
                  }}>
                  <th>{t("Sr.No")}</th>
                  <th>{t("Head")}</th>
                  <th>{t("Fund")}</th>
                  <th>{t("Approvals")}</th>
                  <th>{t("Actions")}</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((item, index) => (
                  <tr key={item.id} style={{
                    borderBottom: '2px dotted #ccc',
                    backgroundColor: 'white'
                  }}>
                    <td>{index + 1}</td>
                    <td>{item.Head}</td>
                    <td><img src={Tax32} style={{ width: '1.3rem' }} />
                      {item.Fund}</td>
                    <td>{item.Approval}</td>
                    <td style={{ padding: '8px' }}>
                      <button
                        onClick={() => handleEdit(item)}
                        className="btn btn-custom-edit"
                        style={{
                          width: '5rem',
                          border: '1px solid #502eff',
                          backgroundColor: 'white',
                          borderRadius: '5px',
                          padding: '5px',
                          fontSize: '14px',
                          color: '#502eff',
                          fontWeight: '700'
                        }}
                      >
                        <img className="icon-edit" src={EditBlueBlue32} style={{ width: '1.3rem' }} /> {t("Edit")}
                      </button>
                      <button
                        onClick={(e) => handleDelete(e, item.id)}
                        className="btn btn-custom-delete"
                        style={{
                          width: '6rem',
                          border: '1px solid #ee5d50',
                          backgroundColor: 'white',
                          borderRadius: '5px',
                          padding: '5px',
                          marginLeft: '10px',
                          color: '#ee5d50',
                          fontSize: '14px',
                          fontWeight: '700'
                        }}
                      >
                        <img className="icon-delete"
                          src={DeleteRed32}
                          style={{ width: '1.3rem', paddingBottom: '0.2rem' }}
                        />{' '}
                        {t("Delete")}
                      </button>
   
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
}
 
export default Budget;